import React from 'react'
import { Track } from 'services/analytics'
import PropTypes from 'prop-types'
import Icon from 'components/icons'
import styles from './social_icons.scss'
import { noop } from 'services/util/abstract'
import {
  FacebookShareButton,
  TwitterShareButton,
  PinterestShareButton,
  EmailShareButton,
} from 'react-share'

const SocialIcons = ({ title, url, media, className, callback = noop, color = 'black' }) => {
  const onSocialClicked = social_network => {
    Track.socialClicked({ social_network })
    callback(social_network)
  }

  return (
    <div className={`social-icons ${className ? className : ''}`}>
      <FacebookShareButton
        url={url}
        quote={title}
        beforeOnClick={() => onSocialClicked('facebook')}>
        <Icon name="facebook" stroke={color} />
      </FacebookShareButton>
      <TwitterShareButton url={url} title={title} beforeOnClick={() => onSocialClicked('twitter')}>
        <Icon name="twitter" stroke={color} />
      </TwitterShareButton>
      <PinterestShareButton
        url={url}
        description={title}
        media={media}
        beforeOnClick={() => onSocialClicked('pinterest')}>
        <Icon name="pinterest" stroke={color} />
      </PinterestShareButton>
      <EmailShareButton
        url={url}
        subject={title}
        body="Check this out:"
        beforeOnClick={() => onSocialClicked('email')}>
        <Icon name="mail" stroke={color} />
      </EmailShareButton>
      <style jsx>{styles}</style>
    </div>
  )
}

SocialIcons.propTypes = {
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  media: PropTypes.string.isRequired,
}

export default SocialIcons
